import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { View, Image } from 'react-native'
import { useTranslation } from 'react-i18next'
import { IonAlert } from '@ionic/react'

import Button from '../../../../components/Button'
import { useLocalPreference } from '../../../global'
import { useAuthContext } from '../../context'

const SignIn = ({ navigation }) => {
  const { signIn } = useAuthContext()
  const { t } = useTranslation()
  const { theme } = useLocalPreference()
  const { palette } = theme

  const [privateModalOpen, setPrivateModalOpen] = useState(false)

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'space-around',
        alignItems: 'center',
        paddingHorizontal: 32,
        backgroundColor: palette.background.default,
      }}>
      <Image style={{ width: 150, height: 150 }} source={require('../../../../assets/icon.png')} />
      <View style={{ width: '100%' }}>
        <Button
          theme={theme}
          label={t('login_as_shared_guest')}
          onPress={() => signIn('DEFAULT')}
          style={{ backgroundColor: palette.self, borderColor: 'transparent' }}
          labelStyle={{ color: 'white' }}
        />
        {/* <Button
          theme={theme}
          label={t('login_as_private_guest')}
          onPress={() => setPrivateModalOpen(true)}
          style={{ marginTop: 12, backgroundColor: palette.self, borderColor: 'transparent' }}
          labelStyle={{ color: 'white' }}
        /> */}
      </View>
      <IonAlert
        isOpen={privateModalOpen}
        onDidDismiss={() => setPrivateModalOpen(false)}
        inputs={[
          {
            name: 'username',
            type: 'text',
            placeholder: t('private_username'),
          }
        ]}
        buttons={[
          {
            text: t('cancel'),
            role: 'cancel',
          },
          {
            text: 'OK',
            handler: data => {
              console.log('data: ', data)
              signIn(data.username)
            }
          }
        ]}
      />
    </View>
  )
}
SignIn.propTypes = {
  navigation: PropTypes.object,
  signIn: PropTypes.func,
}
export default SignIn
